<div class="tw-w-full tw-h-fit tw-flex tw-justify-center tw-items-center tw-my-8">
  <div *ngFor="let step of steps; let i = index" class="tw-w-full tw-h-fit tw-relative tw-flex tw-justify-center tw-items-center">
    <div class="tw-w-fit tw-h-fit tw-relative tw-flex tw-flex-col tw-justify-center tw-items-center tw-overflow-visible">
      <div
        (click)="goToStep(step)"
        [ngClass]="maxStep && maxStep.id >= step.id ? 'tw-bg-primary' : 'tw-bg-secondary/50'"
        class="tw-w-10 tw-h-10 tw-flex tw-justify-center tw-items-center tw-rounded-full"
      >
        <p [ngClass]="maxStep && maxStep.id >= step.id ? 'tw-text-secondary' : 'tw-text-white/50'" class="tw-w-fit tw-h-fit tw-font-poppins tw-font-semibold tw-text-lg">
          {{ step.id }}
        </p>
      </div>
      <p
        [ngClass]="maxStep && maxStep.id >= step.id ? 'tw-text-secondary' : 'tw-text-secondary/50'"
        class="tw-w-fit tw-h-fit tw-absolute tw-top-full tw-font-poppins tw-font-normal tw-text-xs tw-text-center"
      >
        {{ step.title | translate }}
      </p>
    </div>
    <div *ngIf="steps[i + 1]" [ngClass]="maxStep && maxStep.id > step.id ? 'tw-bg-primary' : 'tw-bg-secondary/50'" class="tw-w-16 tw-h-1 tw-sticky tw-left-4"></div>
  </div>
</div>
